module.exports = __webpack_public_path__ + "img/track20.c6cf6f6d.png";